var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIntersection1 = function SvgIntersection1(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.08,
    height: 21.047,
    viewBox: "0 0 16.08 21.047",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Intersection_1",
    "data-name": "Intersection 1",
    d: "M4.385,20.526V0H7.309V21.047A12.48,12.48,0,0,1,4.385,20.526Zm4.385-9.114h2.924v9.114a12.477,12.477,0,0,1-2.924.521ZM0,18.14V14.923H2.924v5.054A12.459,12.459,0,0,1,0,18.14Zm13.157-12H16.08v12a12.46,12.46,0,0,1-2.924,1.837Z",
    fill: "#bcbcbc"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIntersection1);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "Intersection 1.bbc40438ef9e6924fcb66baa19d1f74a.svg";